import options from './autocomplete.component';

export default {
    selector: 'dtSearchAutocomplete',
    options
};



// WEBPACK FOOTER //
// ./app/common/search-autocomplete/index.js